module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraBlackItalic.c99cd02c.ttf";